import { SchoolData } from "@nimble/candidate-api/types";
import { useIsMobile } from "@nimble/react-state-hooks/use-mobile";
import { ReactNode } from "react";

import RespondDrawer, {
  RespondDrawerProps,
} from "@/app/(discover)/candidate/invites/components/respond-drawer";

function DetailDesktop({ children }: { children: ReactNode }) {
  return children;
}

function DetailMobile(props: RespondDrawerProps) {
  return <RespondDrawer {...props} />;
}

export function ChatDetailView({
  children,
  onClose,
  schoolData,
}: {
  children: ReactNode;
  onClose: () => void;
  schoolData: SchoolData;
}) {
  const isMobile = useIsMobile();
  const Component = isMobile ? DetailMobile : DetailDesktop;

  return (
    <Component onClose={onClose} schoolData={schoolData}>
      {children}
    </Component>
  );
}
